/**
 * AuthBottomSheet - BottomSheet container for mobile authentication
 */
import React from 'react';
import { ControlledBottomSheet } from '../../../components/BottomSheet/BottomSheet';
import { useAuthContext } from '../../context/AuthContext';
import AuthContent from './AuthContent';

function AuthBottomSheet() {
  const { isOpen, closeAuth, loading } = useAuthContext();
  
  return (
    <ControlledBottomSheet
      open={isOpen}
      onOpenChange={(open) => !open && !loading && closeAuth()}
      dismissible={!loading}
      showCloseButton
      onClose={closeAuth}
      snapPoints= {[0.8]}
    >
      <AuthContent />
    </ControlledBottomSheet>
  );
}

export default AuthBottomSheet;
